import { render, staticRenderFns } from "./lead-capture.vue?vue&type=template&id=5e3d1a54&scoped=true&lang=pug"
import script from "./lead-capture.vue?vue&type=script&lang=ts"
export * from "./lead-capture.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3d1a54",
  null
  
)

export default component.exports